import { render, staticRenderFns } from "./finance-return-list.vue?vue&type=template&id=65bb264c&"
import script from "./finance-return-list.vue?vue&type=script&lang=js&"
export * from "./finance-return-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports